module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" История счета ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('balancebox', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-5": ""
    }
  }, [_c('div')]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("Транзакции")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.transactions,
      "hide-actions": "",
      "item-key": "date"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.date))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.sum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.comment))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33eda91a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountHistory.vue
// module id = 463
// module chunks = 1